







import {transform} from 'ol/proj';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {},
})
export default class GeoCatchment extends Vue {
  @Action('catchments/calculateQuickCatchment') private calculateQuickCatchment!: any;

  @Getter('map/gps') private gps!: any;
  @Getter('map/name') private name!: any;

  private calculate() {
    this.calculateQuickCatchment({coordinate: transform([this.gps[1], this.gps[0]], 'EPSG:4326', 'EPSG:3857'), name: this.name});
  }
}
